import http from '../../http'
export default {
  fieldList: (params) => {
    //获取所有设置字段
    return http.get('activityservice/basicfield/list', params)
  }, 
  getActiveField:  (data) => {
    //获取活动下报名表单字段
    return http.post('activityservice/signupformmanage/listfield', data)
  }, 
  add: (data) => {
    //添加报名表单内容
    return http.post('activityservice/signupformmanage/save', data)
  },
  list: (data) => {
    //获取可配置的表单管理
    return http.post('activityservice/signupformmanage/list', data)
  },
  update: (data) => {
    //更新表单数据
    return http.post('activityservice/signupformmanage/update', data)
  },
  updateAll: (data) => {
    //批量更新
    return http.post('activityservice/signupformmanage/batch', data)
  },
  delChannelField: (data) => {
    //获取可配置的表单管理
    return http.post('activityservice/signupformmanage/pull', data)
  },
  del: (data) => {
    //删除表单数据
    return http.post('activityservice/signupformmanage/remove', data)
  }
}
